/**
 * @generated SignedSource<<517fb0da6723e23480ce61bdc1384ec7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userProfileQuery$variables = {
  id: string;
  skip: boolean;
};
export type userProfileQuery$data = {
  readonly userProfile?: {
    readonly isExemptFromAgreement: boolean;
    readonly account: {
      readonly accountDetailConnect: {
        readonly " $fragmentSpreads": FragmentRefs<"accountConnectDetailFragment" | "accountConnectDetailInlineFragment">;
      };
      readonly " $fragmentSpreads": FragmentRefs<"accountBaseInlineFragment" | "accountBaseFragment">;
    };
    readonly details: {
      readonly " $fragmentSpreads": FragmentRefs<"userProfileDetailFragment">;
    };
    readonly channels: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"channelMemberDetailFragment">;
    } | null> | null;
    readonly clientDetails: {
      readonly " $fragmentSpreads": FragmentRefs<"userProfileTalkDetailsFragment">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"userProfileNameFragment" | "userProfileBaseFragment" | "userProfileNameInlineFragment" | "userProfileBaseInlineFragment" | "userLocationFragment" | "userProfileAvailabilityFragment">;
  };
};
export type userProfileQuery = {
  variables: userProfileQuery$variables;
  response: userProfileQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExemptFromAgreement",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalRef",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timeZone",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "photoUrls",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "platformAccess",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meetSubdomain",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "businessNumber",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latitude",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "longitude",
  "storageKey": null
},
v19 = [
  (v5/*: any*/),
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userProfileQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "userProfile",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "userProfileNameFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "userProfileBaseFragment"
              },
              {
                "kind": "InlineDataFragmentSpread",
                "name": "userProfileNameInlineFragment",
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              },
              {
                "kind": "InlineDataFragmentSpread",
                "name": "userProfileBaseInlineFragment",
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ]
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "userLocationFragment"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "userProfileAvailabilityFragment"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Account",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineDataFragmentSpread",
                    "name": "accountBaseInlineFragment",
                    "selections": [
                      (v5/*: any*/),
                      (v7/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/),
                      (v13/*: any*/)
                    ]
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "accountBaseFragment"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountDetailConnect",
                    "kind": "LinkedField",
                    "name": "accountDetailConnect",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "accountConnectDetailFragment"
                      },
                      {
                        "kind": "InlineDataFragmentSpread",
                        "name": "accountConnectDetailInlineFragment",
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfileDetailConnect",
                "kind": "LinkedField",
                "name": "details",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "userProfileDetailFragment"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChannelMemberDetail",
                "kind": "LinkedField",
                "name": "channels",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "channelMemberDetailFragment"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientDetails",
                "kind": "LinkedField",
                "name": "clientDetails",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "userProfileTalkDetailsFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userProfileQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "UserProfile",
            "kind": "LinkedField",
            "name": "userProfile",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "languages",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "setupComplete",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "googleCredentials",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "gender",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ethnicity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasAvailability",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sessionDuration",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Account",
                "kind": "LinkedField",
                "name": "account",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccountDetailConnect",
                    "kind": "LinkedField",
                    "name": "accountDetailConnect",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfileDetailConnect",
                "kind": "LinkedField",
                "name": "details",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "roleId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profileInformation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profileSettings",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "defaultSessionPassword",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "zoomDetails",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientLocations",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "preferredVideoType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "googleCalendarSync",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "signedAgreement",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "setupCompletedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CategorisedSpecialities",
                    "kind": "LinkedField",
                    "name": "specialities",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Speciality",
                        "kind": "LinkedField",
                        "name": "approaches",
                        "plural": true,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Speciality",
                        "kind": "LinkedField",
                        "name": "areasOfExpertise",
                        "plural": true,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Speciality",
                        "kind": "LinkedField",
                        "name": "trackingOnlySpecialities",
                        "plural": true,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Speciality",
                        "kind": "LinkedField",
                        "name": "clientGroups",
                        "plural": true,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfileQuestion",
                    "kind": "LinkedField",
                    "name": "profileQuestionResponses",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "answer",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ProfileQuestion",
                        "kind": "LinkedField",
                        "name": "profileQuestion",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "translationKey",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "question",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicationStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "documentStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profileStatus",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onboardingApprovedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "applicationApprovedAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ChannelMemberDetail",
                "kind": "LinkedField",
                "name": "channels",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "channelMemberId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "useAvailability",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "logo",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientDetails",
                "kind": "LinkedField",
                "name": "clientDetails",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isTalk",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isLive",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "cdaf09c0b55e9a4c00b284f2268d8863",
    "id": null,
    "metadata": {},
    "name": "userProfileQuery",
    "operationKind": "query",
    "text": "query userProfileQuery(\n  $id: ID!\n  $skip: Boolean!\n) {\n  userProfile(id: $id) @skip(if: $skip) {\n    isExemptFromAgreement\n    ...userProfileNameFragment\n    ...userProfileBaseFragment\n    ...userProfileNameInlineFragment\n    ...userProfileBaseInlineFragment\n    ...userLocationFragment\n    ...userProfileAvailabilityFragment\n    account {\n      ...accountBaseInlineFragment\n      ...accountBaseFragment\n      accountDetailConnect {\n        ...accountConnectDetailFragment\n        ...accountConnectDetailInlineFragment\n        id\n      }\n      id\n    }\n    details {\n      ...userProfileDetailFragment\n      id\n    }\n    channels {\n      ...channelMemberDetailFragment\n      id\n    }\n    clientDetails {\n      ...userProfileTalkDetailsFragment\n    }\n    id\n  }\n}\n\nfragment accountBaseFragment on Account {\n  id\n  externalRef\n  name\n  platformAccess\n  createdAt\n}\n\nfragment accountBaseInlineFragment on Account {\n  id\n  externalRef\n  name\n  platformAccess\n  createdAt\n}\n\nfragment accountConnectDetailFragment on AccountDetailConnect {\n  type\n  meetSubdomain\n  businessNumber\n  latitude\n  longitude\n}\n\nfragment accountConnectDetailInlineFragment on AccountDetailConnect {\n  type\n  meetSubdomain\n  businessNumber\n  latitude\n  longitude\n}\n\nfragment channelMemberDetailFragment on ChannelMemberDetail {\n  id\n  name\n  channelMemberId\n  useAvailability\n  logo\n}\n\nfragment userLocationFragment on UserProfile {\n  city\n  state\n  countryId\n}\n\nfragment userProfileApplicationStatusFragment on UserProfileDetailConnect {\n  onboardingStatus\n  applicationStatus\n  documentStatus\n  profileStatus\n  setupCompletedAt\n  onboardingApprovedAt\n  applicationApprovedAt\n}\n\nfragment userProfileAvailabilityFragment on UserProfile {\n  hasAvailability\n  sessionDuration\n}\n\nfragment userProfileBaseFragment on UserProfile {\n  id\n  email\n  externalRef\n  countryId\n  timeZone\n  photoUrls\n  phone\n  languages\n  setupComplete\n  googleCredentials\n  gender\n  ethnicity\n}\n\nfragment userProfileBaseInlineFragment on UserProfile {\n  id\n  email\n  externalRef\n  countryId\n  timeZone\n  photoUrls\n}\n\nfragment userProfileDetailFragment on UserProfileDetailConnect {\n  id\n  type\n  roleId\n  profileInformation\n  profileSettings\n  defaultSessionPassword\n  zoomDetails\n  clientLocations\n  preferredVideoType\n  googleCalendarSync\n  signedAgreement\n  setupCompletedAt\n  specialities {\n    approaches {\n      id\n      name\n    }\n    areasOfExpertise {\n      id\n      name\n    }\n    trackingOnlySpecialities {\n      id\n      name\n    }\n    clientGroups {\n      id\n      name\n    }\n  }\n  profileQuestionResponses {\n    id\n    answer\n    profileQuestion {\n      id\n      translationKey\n      question\n    }\n  }\n  ...userProfileApplicationStatusFragment\n}\n\nfragment userProfileNameFragment on UserProfile {\n  firstName\n  lastName\n}\n\nfragment userProfileNameInlineFragment on UserProfile {\n  firstName\n  lastName\n}\n\nfragment userProfileTalkDetailsFragment on ClientDetails {\n  isTalk\n  isLive\n}\n"
  }
};
})();

(node as any).hash = "9fd281bdef7c38a0a5895f204c6601d1";

export default node;
